import React from 'react';
import {
    Route,
    Switch,
} from 'react-router';
import {
   BrowserRouter
} from 'react-router-dom';


import Modal from 'react-modal';

import withHeadSideFoot from './withHeadSideFoot';
import withAuthentication from './auth/withAuthentication';
import SignUpPage from './auth/SignUp';
import SignInPage from './auth/SignIn';
import PasswordForgetPage from './auth/PasswordForget';
import HomePage from './yourpage/HomePage';
import AccountPage from './auth/AccountPage';
import ClueEdit from "./clues/ClueEdit"
import WizardStart from "./huntwizard/WizardStart"
import GameDetail from "./huntedit/GameDetail";

import '../global.css'
import WizardLocation from "./huntwizard/WizardLocation";
import WizardDetails from "./huntwizard/WizardDetails";
import WizardClues from "./huntwizard/WizardClues";
import AdminPage from "./yourpage/AdminPage";
import HuntActivity from "./huntedit/HuntActivity";

const App = () =>

     <div className="container-fluid app-div no-side-padding">

         {/* so screen readers can handle our modals */}
         {Modal.setAppElement(document.getElementById('root'))}

         <BrowserRouter>
            <Switch>
                <Route path="/signup" component={withHeadSideFoot(SignUpPage)}/>
                <Route path="/signin" component={withHeadSideFoot(SignInPage)}/>
                <Route path="/pw-forget" component={withHeadSideFoot(PasswordForgetPage)}/>
                <Route path="/account" component={withHeadSideFoot(AccountPage)}/>
                <Route path="/games/new" component={withHeadSideFoot(WizardStart)}/>
                <Route path="/games/:id/new3" component={withHeadSideFoot(WizardLocation)}/>
                <Route path="/games/:id/new4" component={withHeadSideFoot(WizardDetails)}/>
                <Route path="/games/:id/new5" component={withHeadSideFoot(WizardClues)}/>
                <Route path="/games/:id/clues/edit/:index" component={withHeadSideFoot(ClueEdit, {widerContent: true})}/>
                <Route path="/games/:id/clues/edit" component={withHeadSideFoot(ClueEdit, {widerContent: true})}/>
                <Route path="/games/:id/clues" component={withHeadSideFoot(GameDetail)}/>
                <Route path="/games/:id/activity" component={withHeadSideFoot(HuntActivity)}/>
                <Route path="/games/:id" component={withHeadSideFoot(GameDetail)}/>
                <Route path="/games" component={withHeadSideFoot(HomePage)}/>
                <Route path="/user/:id/:name" component={withHeadSideFoot(HomePage)}/>
                <Route path="/home" component={withHeadSideFoot(HomePage)}/>
                <Route path="/admin" component={withHeadSideFoot(AdminPage)}/>
                <Route path="/" component={withHeadSideFoot(HomePage)}/>
            </Switch>
         </BrowserRouter>;
     </div>

export default withAuthentication(App);



// WEBPACK FOOTER //
// ./src/components/App.js